import { Box, Button, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { stepperStyles } from '../../../shared/styles';
import { useStepperContext } from '../../context/StepperContext';
import { useLoginContext } from '../../../../../contexts/LoginContext';
import { deleteProfile } from '../../../util';
import { useProfileState } from '../../hooks/useProfileState';
import { useAlert } from '@schamburg-web/components';

const ProfileEditButtons: React.FC = () => {
  const { isNewProfile, updateStepValidation, setIsNewProfile, handleReset } =
    useStepperContext();
  const { user, selectedProfileIndex, setSelectedProfileIndex, setUser } =
    useLoginContext();

  const { showAlert } = useAlert();

  const { setActiveStep } = useProfileState();

  const theme = useTheme();
  const isMobile = !useMediaQuery(theme.breakpoints.up('md'));

  const handleNewProfile = () => {
    setActiveStep(0);
    // Create a temporary profile with a placeholder name to ensure name is never empty
    if (user.extProfiles) {
      const tempProfile = {
        id: null,
        agency: null,
        name: 'New Profile', // placeholder name, will be replaced on creation
        enabled: true,
        additionalEmailAddresses: [],
        timeSpans: [],
        allImpactEventTypes: [],
        eventTypeImpacts: {},
        regionlessEventTypes: [],
        extRegions: [],
      };

      const updatedProfiles = [...user.extProfiles, tempProfile];
      const updatedUser = {
        ...user,
        extProfiles: updatedProfiles,
      };

      setUser(updatedUser);

      // Select the temporary profile to clear forms
      const tempIndex = updatedProfiles.length - 1; // This is the index of the newly added profile

      if (setSelectedProfileIndex) {
        setSelectedProfileIndex(tempIndex);
      }

      // Go back to step 0 in the stepper
      if (updateStepValidation) {
        updateStepValidation(0, '', true);
      }
      if (setIsNewProfile) {
        setIsNewProfile(true);
      }
    }
  };

  const handleDeleteProfile = () => {
    if (user.extProfiles && selectedProfileIndex !== undefined) {
      const selectedProfile = user.extProfiles[selectedProfileIndex];
      (async () => {
        const res = await deleteProfile(selectedProfile);
        if (res.success) {
          showAlert('Profile deleted', 'success');
          handleReset();
        } else {
          // Optionally handle error (e.g., show notification)
          // console.error('Failed to delete profile:', exception);
        }
      })();
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: '100%',
        textAlign: 'right',
        gap: 1,
        flex: 0,
        maxWidth: '100%',
        flexWrap: isMobile ? 'wrap' : 'nowrap',
        justifyContent: 'center',
      }}
    >
      <Button
        variant="outlined"
        onClick={handleNewProfile}
        disabled={isNewProfile}
        sx={{
          ...stepperStyles.secondaryButton,
        }}
      >
        New
      </Button>
      {user.extProfiles.length > 1 && (
        <Button
          variant="outlined"
          color="error"
          onClick={handleDeleteProfile}
          disabled={selectedProfileIndex === null || isNewProfile}
          sx={{
            ...stepperStyles.secondaryButton,
          }}
        >
          Delete
        </Button>
      )}
    </Box>
  );
};

export default ProfileEditButtons;
